import { CTBProgram } from "../../utils/api/endpoints/programs/parsePrograms";
import QuickViewModal from "../modal/QuickViewModal";
import StatisticCard from "../../components/dashboard/common/StatisticCard";
import ReportsCounterIcon from "../../assets/icons/ReportsCounterIcon";
import DoughnutChart from "../charts/DoughnutChart";
import TableContainer from "../../components/table/TableContainer";
import TableRow from "../../components/table/TableRow";
import { useEffect, useState } from "react";
import axios from "../../utils/api/axios";

const ProgramStats = ({
  showStats,
  program,
  onClose
}: {
  showStats: boolean;
  program?: CTBProgram;
  onClose: () => void;
}) => {
  const [reportStates, setReportStates] = useState<{}>({});
  const [closedCount, setClosedCount] = useState<number>(0);
  const [openCount, setOpenCount] = useState<number>(0);
  const [severities, setSeverities] = useState<number[] | undefined>();

  const fetchProgramStats = (id: number) => {
    axios
      .get(`v2/programs/get-program-stats?id=${id}`)
      .then(response => {
        const states = response?.data?.states as any;
        const severities = response?.data?.severities as any;
        setReportStates(states);
        if (states) {
          const closedConsideredStates = ["Triage Rejected", "closed"];
          let tempOpenCount = 0;
          let tempClosedCount = 0;
          Object.keys(states).forEach((el: any) => {
            if (closedConsideredStates.includes(el)) {
              tempClosedCount += states[el];
            } else {
              tempOpenCount += states[el];
            }
          });
          const tempSeverities = [
            severities?.CRITICAL ?? 0,
            severities?.HIGH ?? 0,
            severities?.MEDIUM ?? 0,
            severities?.LOW ?? 0,
            (severities?.INFO ?? 0) + (severities?.NONE ?? 0)
          ];
          console.log(tempSeverities);
          setSeverities(tempSeverities);
          setOpenCount(tempOpenCount);
          setClosedCount(tempClosedCount);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (program?.id) {
      fetchProgramStats(program?.id);
    }
  }, [program?.id]);

  return reportStates && Object.keys(reportStates).length ? (
    <QuickViewModal
      title={"Statistics"}
      enabled={showStats}
      onClick={onClose}
      className="flex flex-col"
    >
      <section id="123" className="flex h-full flex-col gap-3 overflow-y-auto">
        <div className="mb-4 flex justify-between">
          <StatisticCard
            icon={ReportsCounterIcon}
            content={openCount?.toString() as string}
            title="OPEN"
            gradientClassName="from-[#DB5E5E] to-[#FA6072]"
            height="60px"
            width="w-30"
            iconWidth="w-1/3"
            contentWidth="w-2/3"
            contentPadding="py-2"
          />
          <StatisticCard
            icon={ReportsCounterIcon}
            content={closedCount?.toString() as string}
            title="CLOSED"
            gradientClassName="from-[#C084FC] to-[#8B5CF6]"
            height="60px"
            width="w-30"
            iconWidth="w-1/3"
            contentWidth="w-2/3"
            contentPadding="py-2"
          />
          <StatisticCard
            icon={ReportsCounterIcon}
            content={(closedCount + openCount)?.toString() as string}
            title="TOTAL"
            gradientClassName="from-[#4ADE80] to-[#22C55E]"
            height="60px"
            width="w-30"
            iconWidth="w-1/3"
            contentWidth="w-2/3"
            contentPadding="py-2"
          />
        </div>
        <h1 className="mb-3 flex justify-between text-xl font-medium leading-[150%] text-ctb-blue">
          Report Severity Overview
        </h1>

        <div className="flex h-[40vh] justify-center">
          {severities && (
            <DoughnutChart
              height={120}
              width={120}
              labels={["CRITICAL", "HIGH", "MEDIUM", "LOW", "INFO"]}
              data={severities}
              backgroundColors={["#DC2626", "#F87171", "#FBBF24", "#22C55E", "#D1D5DB"]}
              hoverBackgroundColors={[
                "#DC2626",
                "#F87171",
                "#FBBF24",
                "#22C55E",
                "#9CA3AF"
              ]}
            />
          )}
        </div>

        <div>
          <TableContainer
            columns={[
              {
                name: "State"
              },
              {
                name: "Reports"
              }
            ]}
          >
            {reportStates &&
              Object.entries(reportStates).map(([key, value]) => (
                <TableRow key={key}>
                  <p className="capitalize">{key}</p>
                  <p>{String(value)}</p>
                </TableRow>
              ))}
          </TableContainer>
        </div>
      </section>
    </QuickViewModal>
  ) : (
    <QuickViewModal
      title={"Statistics"}
      enabled={showStats}
      onClick={onClose}
      className="flex flex-col"
    >
      No Data
    </QuickViewModal>
  );
};

export default ProgramStats;
